import React, { useState , useRef, useEffect} from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import styles from './strangersList.module.css';
import { FcGoogle } from "react-icons/fc";

import Avatar from '@mui/material/Avatar';
import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import { axiosInstance } from '../../../lib/axiosInstance.js';
import dayjs from 'dayjs';

import ToggleButton from '../ToggleButton/ToggleButton.jsx';
import { GrCircleInformation } from "react-icons/gr";
import CircularProgress from '@mui/material/CircularProgress';
import HoverSmallProfile from '../HoverSmallProfile/HoverSmallProfile.jsx';

function StrangersList(props) {
  const [showHoverCard, setShowHoverCard] = useState(false);

  const today = dayjs();

  //console.log("props.bookedPeopleSessionsList : "+JSON.stringify(props.bookedPeopleSessionsList, null, 2));

  const {setShowStrangersList, bookWithStrangersButtonRef, clickedGridTimeInDayHourMinute, subject, topic, setTopic} = useGlobalState();

  const givenTopic = (topic==='')? 'Not given': topic;


  //------------------Handle clickoutside to close strangers list-------------------
  
  const showStrangersListRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (showStrangersListRef.current && !showStrangersListRef.current.contains(event.target) && !bookWithStrangersButtonRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowStrangersList(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
    };
  }, []);



  //-----Getting your name-------
  const [profileName, setProfileName] = useState("");
  useEffect(()=>{
    async function getYourName(){
      try {
        const response = await axiosInstance.get('/profile');
        setProfileName(response.data.name);
        //console.log("response name : "+response.data.name);

      }catch(error){
        console.log("error : "+error);
      }
    }
    getYourName();

  },[]);







  //---------------------Handle direct book-------------------

  const[isDirectBookingDone, setIsDirectBookingDone] = useState({});  // State to track if the booking is done
  const [loading, setLoading] = useState({}); // State to track loading
  async function handleDirectBook(sessionId){
    setLoading((prevLoading) => ({ ...prevLoading, [sessionId]: true })); // Set loading to true for the specific button
    try {
      const response = await axiosInstance.post('/sessions/requests',  {"sessionId": sessionId});   
      setIsDirectBookingDone((prevBooking) => ({ ...prevBooking, [sessionId]: true })); // Set booking status to true for the specific button
      //console.log("response of handleDirectAndRequestBook function : "+JSON.stringify(response.data, null, 2));
      setShowStrangersList(false);   //To close the strangers list after booking.
    } catch (error) {
      //console.log("Error in handleDirectAndRequestBook function : "+error);
      if (error.response) {
        // Server responded with a status other than 200 range
        console.log("Error Data: ", error.response.data);
        console.log("Error Status: ", error.response.status);
        console.log("Error Headers: ", error.response.headers);
      } else if (error.request) {
        // Request was made but no response was received
        console.log("Error Request: ", error.request);
      } else {
        // Something else happened
        console.log("Error Message: ", error.message);
      }
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, [sessionId]: false })); // Set loading to false for the specific button
    }
  }









    //---------------------Handle request book-------------------
    /*
    const[isRequestBookingDone, setIsRequestBookingDone] = useState(false);
    async function handleRequestBook(sessionId){
      try {
        const response = await axiosInstance.post('/sessions/requests',  {"sessionId": sessionId});   
        setIsRequestBookingDone(true);
        console.log("response of handleDirectAndRequestBook function : "+JSON.stringify(response.data, null, 2));
      } catch (error) {
        //console.log("Error in handleDirectAndRequestBook function : "+error);
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
          console.log("Error Status: ", error.response.status);
          console.log("Error Headers: ", error.response.headers);
        } else if (error.request) {
          // Request was made but no response was received
          console.log("Error Request: ", error.request);
        } else {
          // Something else happened
          console.log("Error Message: ", error.message);
        }
      }
    }
    */


  





  //---------------------Handle automatic booking-------------------

  const [mode, setMode] = useState('Public');
  const [autoBookingLoading, setAutoBookingLoading] = useState(false); // State to track loading for automatic book button
  const [isAutomaticBookingDone, setIsAutomaticBookingDone] = useState(false);
  
  async function handleAutomaticBooking(){
    setAutoBookingLoading(true); // Set loading to true for the automatic book button
    try {
      const session = {
        "subject": subject,
        "topic": topic,
        "day": clickedGridTimeInDayHourMinute["dayNumber"],
        "month": clickedGridTimeInDayHourMinute["month"],            //This needs to be changed. It should be the booked day's month in the grid. It need not be today's month.     // If you need leading zero, use 'MM' instead
        "year": clickedGridTimeInDayHourMinute["year"],          //This needs to be changed. It should be the booked day's month in the grid. It need not be today's month.
        "hour": clickedGridTimeInDayHourMinute["hour"],
        "minutes": clickedGridTimeInDayHourMinute["minute"],
        "mode": mode,
        "type":"Discuss and learn with partner",    //category
        "requestFriends":[]
      }
      //console.log("z : "+clickedGridTimeInDayHourMinute["day"]);
      //console.log("x : "+clickedGridTimeInDayHourMinute["hour"]);
      //console.log("c : "+clickedGridTimeInDayHourMinute["minute"]);
      //console.log("v : "+clickedGridTimeInDayHourMinute["month"]);
      //console.log("b : "+clickedGridTimeInDayHourMinute["year"]);




      // const session = {
      //   "subject":"Industrial Engineering",
      //   "topic": "Tools and Die",
      //   "day":11,
      //   "month":10,
      //   "year":2024,
      //   "hour":4,
      //   "minutes":15,
      //   "mode":"Public",
      //   "type":"Discuss and learn with partner",
      //   "requestFriends":[]
      // }

      //console.log("session : "+JSON.stringify(session, null, 2));

      const response = await axiosInstance.post('/sessions',  session);   
      setIsAutomaticBookingDone(true);
      //console.log("response of handleAutomaticBooking function : "+JSON.stringify(response.data, null, 2));
      setTopic("");
      setShowStrangersList(false);  //To close the strangers list after booking.
      
    } catch (error) {
      //console.log("Error in handleAutomaticBooking function : "+error);
      if (error.response) {
        // Server responded with a status other than 200 range
        console.log("Error Data: ", error.response.data);
        console.log("Error Status: ", error.response.status);
        console.log("Error Headers: ", error.response.headers);
      } else if (error.request) {
        // Request was made but no response was received
        console.log("Error Request: ", error.request);
      } else {
        // Something else happened
        console.log("Error Message: ", error.message);
      }
    } finally {
      setAutoBookingLoading(false); // Set loading to false for the automatic book button
    }
  }
  






  
  //------------To get the profile details of the booked people----------------
  const [profileDetails, setProfileDetails] = useState({});

  useEffect(() => {
    const fetchProfileDetails = async () => {
      const details = {};
      for (const item of props.bookedPeopleSessionsList) {
        try {
          const response = await axiosInstance.get(`/profile/?userID=${item.createdBy}`);
          //details[item.createdBy] = response.data.name;  // {userId1: name1, userId2: name2, ...}
          details[item.createdBy] = {
            "name": response.data.name, 
            "titleOrOccupation": response.data.titleOrOccupation, 
            "collegeOrCompany": response.data.collegeOrCompany, 
            "majorInCollegeOrSpecialisation": response.data.majorInCollegeOrSpecialisation
          }; // {userId1: {"name": name1, "titleOrOccupation": titleOrOccupation1, "collegeOrCompany": collegeOrCompany1, "majorInCollegeOrSpecialisation": majorInCollegeOrSpecialisation1}, userId2: {...}, ...}
        } catch (error) {
          console.error('Error fetching profile details:', error);
          if (error.response) {
            // Server responded with a status other than 200 range
            console.log("Error Data: ", error.response.data);
          }
        }
      }
      setProfileDetails(details);
    };

    fetchProfileDetails();
  }, [props.bookedPeopleSessionsList]);


  

  //------------------return-------------------

  return (
    <div ref={showStrangersListRef} className={styles.strangers_list}>
      <div className={styles.title_and_close_icon_div}>
        <h2 className={styles.h2}>People</h2>
        <IoMdClose onClick={()=>setShowStrangersList(false)} className={styles.close_icon}/>
      </div>

      <div className={styles.person_details_title_div}>
          <div className={styles.person_avatar_name_div}>
            {/*<Avatar className={styles.avatar_class} alt="Paul" src='/images/paul.jpg'/>*/}
            <p className={styles.person_name_title_class}>Name</p>
          </div>

          <div className={styles.topic_div}>
            <p className={styles.person_topic_title_chosen}>Topic</p>
          </div>

          {/* <div className={styles.mode_div}>
            <p className={styles.person_mode_title_chosen}>Mode</p>
            <GrCircleInformation onMouseOver={() => 1} onMouseOut={1} className={styles.i_icon}/>
          </div> */}

          <div className={styles.book_button_div}>
            <p className={styles.strangers_book_title}>Booking</p>
          </div>
      </div>





      
      {/*-------Yours---------*/}
      <div className={styles.person_details_div}>
        <div className={styles.person_avatar_name_div}>
          <Avatar className={styles.avatar_class} alt="your_avatar" src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?type=thumbnail`}/>
          <p className={styles.person_name_class}>{profileName}</p>
        </div>

        <div className={styles.topic_div}>
          <p className={styles.person_topic_class_chosen}>{givenTopic}</p>
        </div>
        
        {/* <div className={styles.mode_div}>
          <ToggleButton active={mode} setActive={setMode}/>
        </div> */}

        <div className={styles.book_button_div}>
          <button className={styles.strangers_book_button}>
            You
          </button>
        </div>
      </div>


      {/*-------------------*/}

      <hr className={styles.hr}/>


      {/*------------------*/}

      <div className={styles.person_details}>
        {props.bookedPeopleSessionsList.map(function (item, index){
          return(
            <div key={index} className={styles.person_details_div}>
              <div className={styles.person_avatar_name_div} style={{ position: 'relative' }}>
                <Avatar className={styles.avatar_class} alt="booked_people_avatar" src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${item.createdBy}&type=profile`}/>
                <p 
                  className={styles.person_name_class}
                  onMouseEnter={() => setShowHoverCard(true)}
                  onMouseLeave={() => setShowHoverCard(false)}
                >
                  {/*profileDetails[item.createdBy]["name"] || 'Loading...'*/}   {/*This will give error if the profileDetails[item.createdBy] is not present. So use the below line.*/}
                  {/*profileDetails[item.createdBy] && (profileDetails[item.createdBy]["name"] || 'Loading...')*/}
                  {profileDetails[item.createdBy]?.name ?? 'Loading...'}
                </p>
                {showHoverCard &&  profileDetails[item.createdBy] && (
                  <HoverSmallProfile 
                    name={profileDetails[item.createdBy]["name"]}
                    titleOrOccupation={profileDetails[item.createdBy]["titleOrOccupation"]}
                    collegeOrCompany={profileDetails[item.createdBy]["collegeOrCompany"]}
                    majorInCollegeOrSpecialisation={profileDetails[item.createdBy]["majorInCollegeOrSpecialisation"]}
                    profilePicUrl={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${item.createdBy}&type=profile`}
                  />
                )}
              </div>
              
              <div className={styles.topic_div}>
                <p className={styles.person_topic_class_chosen}>{item.topic}</p>
              </div>
              
              {/* <div className={styles.mode_div}>
                <p className={styles.person_mode_class_chosen}>{item.mode}</p>
              </div> */}

              <div className={styles.book_button_div}>
                <button 
                  onClick={()=>{handleDirectBook(item._id)}} 
                  className={styles.strangers_book_button} 
                  disabled={loading[item._id]} // Disable the button while loading
                >
                  {loading[item._id] ? <CircularProgress size={24} /> : (isDirectBookingDone[item._id] ? 'Booked' : 'Book')}
                </button> 
              </div>

            </div>
          )}    
        )}
 
      </div>


      <div className={styles.automatically_pair_strangers_button} onClick={handleAutomaticBooking}>        
        {autoBookingLoading ? (
          <CircularProgress size={24} />
        ) : (
        <>
          <span >{isAutomaticBookingDone===true ? "Great! We will find you a match!" : "Automatically pair me when someone of the same topic books"}</span>
          <span style={{ fontSize: "0.61rem" }}>{isAutomaticBookingDone===true ? '(If no one is found of the same topic before the session starts, you will paired with the remaining people.)' : '(Use this option to book if you are early and do not find anyone learning the same topic.)'}</span>
        </>
        )}
      </div>
    </div>
  );
}

export default StrangersList;
